/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Base document record returned by the API.
 * @export
 * @interface Document
 */
export interface Document {
    /**
     * 
     * @type {number}
     * @memberof Document
     */
    readonly id: number;
    /**
     * 
     * @type {number}
     * @memberof Document
     */
    companyId: number;
    /**
     * 
     * @type {number}
     * @memberof Document
     */
    uploadedBy: number;
    /**
     * 
     * @type {number}
     * @memberof Document
     */
    claimId: number;
    /**
     * Optional folder ID for organizing documents within a claim
     * @type {number}
     * @memberof Document
     */
    folderId?: number | null;
    /**
     * Kind of document (insurer or contractor)
     * @type {string}
     * @memberof Document
     */
    kind: DocumentKindEnum;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    filename: string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    mimeType: string;
    /**
     * 
     * @type {number}
     * @memberof Document
     */
    sizeBytes: number | null;
    /**
     * Document parsing status
     * @type {string}
     * @memberof Document
     */
    parseStatus: DocumentParseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    parseError?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Document
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Document
     */
    readonly updatedAt: Date;
}


/**
 * @export
 */
export const DocumentKindEnum = {
    Insurer: 'insurer',
    Contractor: 'contractor'
} as const;
export type DocumentKindEnum = typeof DocumentKindEnum[keyof typeof DocumentKindEnum];

/**
 * @export
 */
export const DocumentParseStatusEnum = {
    Pending: 'pending',
    Parsed: 'parsed',
    Failed: 'failed'
} as const;
export type DocumentParseStatusEnum = typeof DocumentParseStatusEnum[keyof typeof DocumentParseStatusEnum];


/**
 * Check if a given object implements the Document interface.
 */
export function instanceOfDocument(value: object): value is Document {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('uploadedBy' in value) || value['uploadedBy'] === undefined) return false;
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('filename' in value) || value['filename'] === undefined) return false;
    if (!('mimeType' in value) || value['mimeType'] === undefined) return false;
    if (!('sizeBytes' in value) || value['sizeBytes'] === undefined) return false;
    if (!('parseStatus' in value) || value['parseStatus'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function DocumentFromJSON(json: any): Document {
    return DocumentFromJSONTyped(json, false);
}

export function DocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Document {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'uploadedBy': json['uploadedBy'],
        'claimId': json['claimId'],
        'folderId': json['folderId'] == null ? undefined : json['folderId'],
        'kind': json['kind'],
        'filename': json['filename'],
        'mimeType': json['mimeType'],
        'sizeBytes': json['sizeBytes'],
        'parseStatus': json['parseStatus'],
        'parseError': json['parseError'] == null ? undefined : json['parseError'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function DocumentToJSON(json: any): Document {
    return DocumentToJSONTyped(json, false);
}

export function DocumentToJSONTyped(value?: Omit<Document, 'id'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyId': value['companyId'],
        'uploadedBy': value['uploadedBy'],
        'claimId': value['claimId'],
        'folderId': value['folderId'],
        'kind': value['kind'],
        'filename': value['filename'],
        'mimeType': value['mimeType'],
        'sizeBytes': value['sizeBytes'],
        'parseStatus': value['parseStatus'],
        'parseError': value['parseError'],
    };
}

